export const translationsExtra = {
  it: {
    nav: { gallery: 'Gallery' },
    meta: {
      galleryTitle: 'Gallery — Foto Eventi | Gustavo 28 Milano',
      galleryDesc: 'Le foto dei nostri eventi: cooking team building, degustazioni, catering e serate nella location di Via Gustavo Modena 28, Milano.',
    },
    home: { galleryCta: 'Vedi tutte le foto' },
    tb: {
      packagesKicker: 'I pacchetti',
      packagesTitle: 'Tutto incluso, dal welcome alla degustazione',
      includeTitle: 'Ogni pacchetto include',
      includes: [
        'Minimo 3 ore: welcome, attività e degustazione dei piatti cucinati',
        'Cibo di alta qualità, acqua e vino',
        'Grembiuli e cappelli per l\u2019attività',
        'Staff dedicato: chef, cameriere, lavapiatti, addetto evento',
        'Possibilità di ore extra per riunioni, cocktail o presentazioni',
        'Gadget, servizi extra e tutor (coach, psicologo, formatore, nutrizionista) su richiesta',
      ],
      formatsTitle: 'I format',
      formatsList: ['Mistery box', 'Cucina vegetariana o vegan', 'Tradizione italiana o estera', 'Senza sprechi', 'Creativa', 'A tema, a sorpresa o a quiz (wine & cocktail)'],
      sizesTitle: 'Per quanti ospiti?',
      sizes: [
        { label: 'Cooking Challenge', range: '6 – 100' },
        { label: 'Wine Team Building', range: '6 – 200' },
        { label: 'Mixology Team Building', range: '6 – 200' },
        { label: 'Food Art & Design', range: '6 – 35' },
      ],
      sizesNote: 'Per i gruppi più numerosi ci spostiamo in location dedicate, scelte insieme a te.',
    },
    galleryPage: {
      kicker: 'Gallery',
      title: 'I nostri eventi',
      intro: 'Momenti veri dai nostri eventi: cooking challenge, degustazioni, catering e serate nella nostra location.',
    },
  },
  en: {
    nav: { gallery: 'Gallery' },
    meta: {
      galleryTitle: 'Gallery — Event Photos | Gustavo 28 Milan',
      galleryDesc: 'Photos from our events: cooking team building, tastings, catering and evenings at our venue in Via Gustavo Modena 28, Milan.',
    },
    home: { galleryCta: 'See all photos' },
    tb: {
      packagesKicker: 'The packages',
      packagesTitle: 'All-inclusive, from welcome to tasting',
      includeTitle: 'Every package includes',
      includes: [
        'Minimum 3 hours: welcome, activity and tasting of the dishes prepared',
        'High-quality food, water and wine',
        'Aprons and chef hats for the activity',
        'Dedicated staff: chef, waiter, dishwasher, event assistant',
        'Extra hours available for meetings, cocktails or presentations',
        'Gadgets, extra services and tutors (coach, psychologist, trainer, nutritionist) on request',
      ],
      formatsTitle: 'The formats',
      formatsList: ['Mystery box', 'Vegetarian or vegan cuisine', 'Italian or international tradition', 'Zero waste', 'Creative', 'Themed, surprise or quiz (wine & cocktail)'],
      sizesTitle: 'For how many guests?',
      sizes: [
        { label: 'Cooking Challenge', range: '6 – 100' },
        { label: 'Wine Team Building', range: '6 – 200' },
        { label: 'Mixology Team Building', range: '6 – 200' },
        { label: 'Food Art & Design', range: '6 – 35' },
      ],
      sizesNote: 'For larger groups we move to dedicated venues, chosen together with you.',
    },
    galleryPage: {
      kicker: 'Gallery',
      title: 'Our events',
      intro: 'Real moments from our events: cooking challenges, tastings, catering and evenings at our venue.',
    },
  },
  es: {
    nav: { gallery: 'Galería' },
    meta: {
      galleryTitle: 'Galería — Fotos de Eventos | Gustavo 28 Milán',
      galleryDesc: 'Las fotos de nuestros eventos: cooking team building, catas, catering y veladas en la location de Via Gustavo Modena 28, Milán.',
    },
    home: { galleryCta: 'Ver todas las fotos' },
    tb: {
      packagesKicker: 'Los paquetes',
      packagesTitle: 'Todo incluido, de la bienvenida a la degustación',
      includeTitle: 'Cada paquete incluye',
      includes: [
        'Mínimo 3 horas: bienvenida, actividad y degustación de los platos cocinados',
        'Comida de alta calidad, agua y vino',
        'Delantales y gorros para la actividad',
        'Personal dedicado: chef, camarero, lavaplatos, responsable de evento',
        'Posibilidad de horas extra para reuniones, cócteles o presentaciones',
        'Gadgets, servicios extra y tutores (coach, psicólogo, formador, nutricionista) bajo petición',
      ],
      formatsTitle: 'Los formatos',
      formatsList: ['Mistery box', 'Cocina vegetariana o vegana', 'Tradición italiana o internacional', 'Sin desperdicios', 'Creativa', 'Temática, sorpresa o quiz (vino y cóctel)'],
      sizesTitle: '¿Para cuántos invitados?',
      sizes: [
        { label: 'Cooking Challenge', range: '6 – 100' },
        { label: 'Wine Team Building', range: '6 – 200' },
        { label: 'Mixology Team Building', range: '6 – 200' },
        { label: 'Food Art & Design', range: '6 – 35' },
      ],
      sizesNote: 'Para los grupos más numerosos nos trasladamos a espacios dedicados, elegidos junto contigo.',
    },
    galleryPage: {
      kicker: 'Galería',
      title: 'Nuestros eventos',
      intro: 'Momentos reales de nuestros eventos: cooking challenge, catas, catering y veladas en nuestra location.',
    },
  },
  de: {
    nav: { gallery: 'Galerie' },
    meta: {
      galleryTitle: 'Galerie — Event-Fotos | Gustavo 28 Mailand',
      galleryDesc: 'Fotos unserer Events: Cooking-Teambuilding, Verkostungen, Catering und Abende in der Location in der Via Gustavo Modena 28, Mailand.',
    },
    home: { galleryCta: 'Alle Fotos ansehen' },
    tb: {
      packagesKicker: 'Die Pakete',
      packagesTitle: 'Alles inklusive, vom Welcome bis zur Verkostung',
      includeTitle: 'Jedes Paket beinhaltet',
      includes: [
        'Mindestens 3 Stunden: Welcome, Aktivität und Verkostung der zubereiteten Gerichte',
        'Hochwertige Speisen, Wasser und Wein',
        'Schürzen und Kochmützen für die Aktivität',
        'Dediziertes Team: Koch, Kellner, Spüler, Event-Assistent',
        'Zusätzliche Stunden für Meetings, Cocktails oder Präsentationen möglich',
        'Gadgets, Zusatzleistungen und Tutoren (Coach, Psychologe, Trainer, Ernährungsberater) auf Anfrage',
      ],
      formatsTitle: 'Die Formate',
      formatsList: ['Mystery Box', 'Vegetarische oder vegane Küche', 'Italienische oder internationale Tradition', 'Zero Waste', 'Kreativ', 'Themen-, Überraschungs- oder Quiz-Format (Wein & Cocktail)'],
      sizesTitle: 'Für wie viele Gäste?',
      sizes: [
        { label: 'Cooking Challenge', range: '6 – 100' },
        { label: 'Wine Teambuilding', range: '6 – 200' },
        { label: 'Mixology Teambuilding', range: '6 – 200' },
        { label: 'Food Art & Design', range: '6 – 35' },
      ],
      sizesNote: 'Für größere Gruppen ziehen wir in spezielle Locations um, die wir gemeinsam mit Ihnen auswählen.',
    },
    galleryPage: {
      kicker: 'Galerie',
      title: 'Unsere Events',
      intro: 'Echte Momente unserer Events: Cooking Challenges, Verkostungen, Catering und Abende in unserer Location.',
    },
  },
};
